"use client";

import { Route } from "@faire/web-api/Route";
import { props as smallBusinessGrantRoute } from "@faire/web-api/routes/small-business-grant";
import { useStrictLocalization } from "@faire/web/common/localization";
import { formatMoney, RoundingStrategy } from "@faire/web/common/money";
import React from "react";

import { FaireHelmet } from "@faire/retailer/components/Helmet";
import { getSettingOwFGrantMoney } from "@faire/retailer/settings/getSettingOwFGrantMoney";
import { useSettingOwFGrant } from "@faire/retailer/settings/useSettingOwFGrant";
import { LazyBuilderLandingPage } from "@faire/retailer/views/builder";
import { LazyOwFGrantLandingPage } from "@faire/retailer/views/owf-small-business-grant/LazyOwFGrantLandingPage";

export const RenderSmallBusinessGrantRoute = () => {
  const isOwFGrant = useSettingOwFGrant();
  const { strictLocalize } = useStrictLocalization();
  const Component = isOwFGrant
    ? LazyOwFGrantLandingPage
    : LazyBuilderLandingPage;

  const formattedGrantMoney = formatMoney({
    money: getSettingOwFGrantMoney(),
    roundingStrategy: RoundingStrategy.DROP_CENTS,
  });

  return (
    <>
      <FaireHelmet
        alignOpenGraphTitleDescription
        title={strictLocalize(
          {
            defaultMessage: "Get {grantMoney} to stock your new store",
            description: {
              text: "Landing page header card for a grant being offered to businesses",
              img: "https://cdn.faire.com/fastly/2e451c93a50386f946acc5ae2b66ffe53e2e2cdf8bd07771f6d2a05cb84f2273.png",
            },
          },
          {
            grantMoney: formattedGrantMoney,
          }
        )}
        description={strictLocalize(
          {
            defaultMessage:
              "Our small business grant program gives select new stores {grantMoney} to use on Faire to stock their shelves with amazing products. It’s our way of helping you kickstart your dream shop.",
            description: {
              text: "Landing page disclaimer card for a grant being offered to businesses",
              img: "https://cdn.faire.com/fastly/3341d490198effd999c2a528f215241c012b49cc3de92fed2b9130082dc3965c.png",
            },
          },
          {
            grantMoney: formattedGrantMoney,
          }
        )}
      />

      <Route {...smallBusinessGrantRoute} component={Component} />
    </>
  );
};
